import React from 'react';
import { Col, Container, Row } from 'reactstrap';

const StaticFooter = () => {
  return (
    <React.Fragment>
      {/* <footer className="custom-footer bg-dark py-5 d-flex flex-column">
        <div className="text-center fs-5">Footer</div>
      </footer> */}
      <footer className="footer bg-dark w-100">
        <Container fluid>
          <Row>
            <Col sm={6}>{new Date().getFullYear()} © GGH.</Col>
            <Col sm={6}>
              {/* <div className="text-sm-end d-none d-sm-block">Member UI </div> */}
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default StaticFooter;
